import React, { useEffect, useState } from "react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
export default function Pagination({
  updateShowPerpagevalue,
  showPrePage,
  onPaginationChange,
  total,
  paginationTypeApi,
  pageNumber,
  setPageNumber,
  recordLength,
  setRecordLength,
  totalLength,
}) {
  const [counter, setCounter] = useState(1);
  const [numberOfButton, setNumberOfButton] = useState();
  // console.log("onPaginationChange", onPaginationChange);
  useEffect(() => {
    const value = showPrePage * counter;
    if (typeof onPaginationChange === "function") {
      onPaginationChange(value - showPrePage, value);
    }
    setNumberOfButton(Math.ceil(total / showPrePage));
  }, [counter, total]);

  React.useEffect(() => {
    updateShowPerpagevalue(10);
  }, []);

  const onButtonClick = (type) => {
    if (type === "p") {
      if (counter === 1) {
        setCounter(1);
      } else {
        setCounter(counter - 1);
      }
    } else if (type === "n") {
      if (numberOfButton === counter) {
        setCounter(counter);
      } else {
        setCounter(counter + 1);
      }
    }
  };
  return (
    <div className="premium-pagination-container mt-4 pr-4">
      {paginationTypeApi ? (
        <>
          <select
            name="showPrePage"
            id="showPrePage"
            value={recordLength}
            className="premium-pagination-select"
            onChange={(e) => setRecordLength(parseInt(e.target.value))}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>

          <nav aria-label="Page navigation">
            <ul className="premium-pagination-list">
              <li className="premium-pagination-item">
                <button
                  className="premium-pagination-link"
                  onClick={() => setPageNumber(1)}
                  disabled={pageNumber === 1}
                >
                  <KeyboardDoubleArrowLeftIcon style={{ fontSize: "16px" }} />
                </button>
              </li>
              <li className="premium-pagination-item">
                <button
                  className="premium-pagination-link"
                  onClick={() => setPageNumber(pageNumber - 1)}
                  disabled={pageNumber === 1}
                >
                  <KeyboardArrowLeftIcon style={{ fontSize: "16px" }} />
                </button>
              </li>

              {pageNumber > 1 && (
                <li className="premium-pagination-item">
                  <button
                    className="premium-pagination-link"
                    onClick={() => setPageNumber(pageNumber - 1)}
                  >
                    {pageNumber - 1}
                  </button>
                </li>
              )}

              <li className="premium-pagination-item">
                <button className="premium-pagination-link active">
                  {pageNumber}
                </button>
              </li>

              {pageNumber < parseInt(totalLength / recordLength + 1) && (
                <li className="premium-pagination-item">
                  <button
                    className="premium-pagination-link"
                    onClick={() => setPageNumber(pageNumber + 1)}
                  >
                    {pageNumber + 1}
                  </button>
                </li>
              )}

              <li className="premium-pagination-item">
                <button
                  className="premium-pagination-link"
                  onClick={() => setPageNumber(pageNumber + 1)}
                  disabled={pageNumber === parseInt(totalLength / recordLength + 1)}
                >
                  <KeyboardArrowRightIcon style={{ fontSize: "16px" }} />
                </button>
              </li>

              <li className="premium-pagination-item">
                <button
                  className="premium-pagination-link"
                  onClick={() => setPageNumber(parseInt(totalLength / recordLength + 1))}
                  disabled={pageNumber === parseInt(totalLength / recordLength + 1)}
                >
                  <KeyboardDoubleArrowRightIcon style={{ fontSize: "16px" }} />
                </button>
              </li>
            </ul>
          </nav>
        </>
      ) : (
        <>
          <select
            name="showPrePage"
            id="showPrePage"
            value={showPrePage}
            className="premium-pagination-select"
            onChange={(e) => updateShowPerpagevalue(parseInt(e.target.value))}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>

          <nav aria-label="Page navigation">
            <ul className="premium-pagination-list">
              <li className="premium-pagination-item">
                <button
                  className="premium-pagination-link"
                  onClick={() => setCounter(1)}
                  disabled={counter === 1}
                >
                  <KeyboardDoubleArrowLeftIcon style={{ fontSize: "16px" }} />
                </button>
              </li>
              <li className="premium-pagination-item">
                <button
                  className="premium-pagination-link"
                  onClick={() => onButtonClick("p")}
                  disabled={counter === 1}
                >
                  <KeyboardArrowLeftIcon style={{ fontSize: "16px" }} />
                </button>
              </li>

              {new Array(numberOfButton)?.fill("")?.map((_, index) => {
                const pageNum = index + 1;
                if (
                  pageNum === counter ||
                  pageNum === counter - 1 ||
                  pageNum === counter + 1
                ) {
                  return (
                    <li className="premium-pagination-item" key={index}>
                      <button
                        className={`premium-pagination-link ${pageNum === counter ? "active" : ""}`}
                        onClick={() => setCounter(pageNum)}
                      >
                        {pageNum}
                      </button>
                    </li>
                  );
                }
                return null;
              })}

              <li className="premium-pagination-item">
                <button
                  className="premium-pagination-link"
                  onClick={() => onButtonClick("n")}
                  disabled={counter === numberOfButton}
                >
                  <KeyboardArrowRightIcon style={{ fontSize: "16px" }} />
                </button>
              </li>
              <li className="premium-pagination-item">
                <button
                  className="premium-pagination-link"
                  onClick={() => setCounter(numberOfButton)}
                  disabled={counter === numberOfButton}
                >
                  <KeyboardDoubleArrowRightIcon style={{ fontSize: "16px" }} />
                </button>
              </li>
            </ul>
          </nav>
        </>
      )}
    </div>
  );
}
